export const NAVIGATION = {
    name: 'Support',
    icon: 'fa-phone',
    path: '/module/support/info'
};
